// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jL5Yr","delete":"styles_delete__1O20o","update":"styles_update__mOK3_","add":"styles_add__2Y5D4"};